// Client-portal feature flags. Additive gates for launch; flip to restore.
export const AI_ASSISTANT_ENABLED = false;
